import { Button, Modal } from "antd";
import { useEffect, useState } from "react";

const CustomModal = ({
  title = "Modal Title",
  children,
  modalOpen = false,
  onClose,
  footer,
  width = 500,
  closable = true,
  maskClosable = true,
}) => {
  const [isOpen, setIsOpen] = useState(modalOpen);

  useEffect(() => {
    setIsOpen(modalOpen);
  }, [modalOpen]);

  return (
    <Modal
      title={<div className="text-2xl">{title}</div>}
      centered
      open={isOpen}
      width={width}
      closable={closable}
      maskClosable={maskClosable}
      onCancel={() => {
        setIsOpen(false);
        onClose();
      }}
      footer={
        footer !== undefined ? (
          footer
        ) : (
          <div className="flex items-center justify-end gap-3">
            <Button
              type="primary"
              onClick={() => {
                setIsOpen(false);
                onClose();
              }}
            >
              Okay
            </Button>
          </div>
        )
      }
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
